import { MessageCircle } from "lucide-react";
import { offer, site, whatsappPrefill } from "@/config/site";
import { RMark } from "./RMark";
import { Reveal } from "./Reveal";

export const FinalOffer = () => (
    <section
        aria-labelledby="final-offer-title"
        className="relative border-t border-rz-steel/60 bg-rz-carbon"
    >
        <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-32">
            <Reveal className="flex flex-col items-start gap-8 lg:flex-row lg:items-center lg:justify-between">
                <div>
                    <div className="flex items-center gap-3">
                        <RMark className="h-5 w-5 text-rz-smoke" />
                        <p className="font-display text-[11px] uppercase tracking-[0.25em] text-rz-smoke">
                            <span className="text-rz-red">15</span>
                            <span className="mx-2 text-rz-steel">/</span> {offer.label}
                        </p>
                    </div>
                    <h2
                        id="final-offer-title"
                        className="mt-5 max-w-3xl font-display text-3xl font-bold uppercase leading-[1.02] tracking-tight text-rz-white sm:text-4xl lg:text-5xl"
                    >
                        Ready to find out what your car needs?
                    </h2>
                    <p className="mt-4 font-display text-lg font-bold uppercase tracking-wide text-rz-white">
                        Up to <span className="text-rz-red">20% off</span> select services
                        <span className="mx-3 text-rz-steel">+</span>
                        Free car inspection report
                    </p>
                </div>
                <div className="flex shrink-0 flex-col gap-4 sm:flex-row lg:flex-col">
                    <a
                        data-testid="final-offer-cta"
                        href={whatsappPrefill(offer.message)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-sweep bg-rz-red px-10 py-4 text-center font-display text-[13px] font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:bg-rz-reddeep"
                    >
                        {offer.cta}
                    </a>
                    <a
                        data-testid="final-offer-whatsapp"
                        href={site.whatsappLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center gap-2 border border-rz-white/40 px-10 py-4 font-display text-[13px] font-semibold uppercase tracking-[0.18em] text-rz-white transition-colors duration-300 hover:border-rz-white"
                    >
                        <MessageCircle size={15} /> WhatsApp Revautoz
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
